import classNames from "classnames";
import * as React from "react";
import Section from "../Layout/Section";
import SectionTitle from "../Layout/Section/Title";
import SectionDescription from "../Layout/Section/Description";
import TemplateString from "../Common/TemplateString";
import Media from "../Common/Media";
import * as capabilitiesStyles from "./capabilities.module.css";

const Capabilities = ({
    sectionTitle,
    description,
    capabilityItems,
    column = 3,
    titleLeft = false,
    titleMaxWidth = "auto",
    itemImageLeft = false,
}) => {
    return (
        <Section id="capabilities">
            <SectionTitle>
                <span
                    className={classNames(capabilitiesStyles.capabilities__title, {
                        [capabilitiesStyles.capabilities__title_left]: titleLeft,
                    })}
                    style={{"--mw": titleMaxWidth}}
                >
                    <TemplateString template={sectionTitle} />
                </span>
            </SectionTitle>
            {description && (
                <SectionDescription>
                    <TemplateString template={description} />
                </SectionDescription>
            )}
            <div
                className={classNames({
                    [capabilitiesStyles.capabilities__list]: true,
                    [capabilitiesStyles.capabilities__list_size_small]: column === 2,
                })}
            >
                {capabilityItems.map(({id, title, description: itemDescription, icon}) => {
                    return (
                        <div
                            key={id}
                            className={classNames(capabilitiesStyles.capabilities__item, {
                                [capabilitiesStyles.capabilities__item_icon_left]: itemImageLeft,
                            })}
                        >
                            <Media
                                media={{content: icon, youtubeVideoURL: ""}}
                                className={capabilitiesStyles.capabilities__itemIcon}
                            />
                            <div>
                                <h2 className={capabilitiesStyles.capabilities__itemTitle}>{title}</h2>
                                <p className={capabilitiesStyles.capabilities__itemDesc}>
                                    <TemplateString template={itemDescription} />
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Section>
    );
};

export default Capabilities;
